var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortArrows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92422 2.52917V9.50313C8.92422 9.73785 8.73394 9.92813 8.49922 9.92813C8.2645 9.92813 8.07422 9.73785 8.07422 9.50313V2.52917L6.79974 3.80365C6.63377 3.96962 6.36467 3.96962 6.1987 3.80365C6.03273 3.63767 6.03273 3.36858 6.1987 3.2026L8.1987 1.20261C8.36467 1.03663 8.63377 1.03663 8.79974 1.20261L10.7997 3.2026C10.9657 3.36858 10.9657 3.63767 10.7997 3.80365C10.6338 3.96962 10.3647 3.96962 10.1987 3.80365L8.92422 2.52917ZM3.92422 2.50313C3.92422 2.2684 3.73394 2.07813 3.49922 2.07813C3.2645 2.07813 3.07422 2.2684 3.07422 2.50313V9.47709L1.79974 8.2026C1.63377 8.03663 1.36467 8.03663 1.1987 8.2026C1.03273 8.36858 1.03273 8.63767 1.1987 8.80365L3.1987 10.8036C3.36467 10.9696 3.63377 10.9696 3.79974 10.8036L5.79974 8.80365C5.96571 8.63767 5.96571 8.36858 5.79974 8.2026C5.63377 8.03663 5.36467 8.03663 5.1987 8.2026L3.92422 9.47708V2.50313Z",
    fill: "#7C8DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrows);
export default __webpack_public_path__ + "static/media/sort_arrows.f08006a41080270db73bc2d946a7a526.svg";
export { ForwardRef as ReactComponent };